module.exports = __webpack_public_path__ + "static/media/ui and ux.64295622.jpg";